import { NgModule } from '@angular/core';
import { LibUploadIconComponent } from './lib-upload-icon.component';

@NgModule({
  declarations: [LibUploadIconComponent],
  imports: [],
  exports: [LibUploadIconComponent],
})
export class LibUploadIconModule {}
